import { ColorClass_ColorAdjust_$ctor_Z207A3CFB, ColorClass_Color_$ctor_Z207A3CFB } from "../Types/Color.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const Color = ColorClass_Color_$ctor_Z207A3CFB(new Property_CssProperty(72));

export const ColorAdjust = ColorClass_ColorAdjust_$ctor_Z207A3CFB(new Property_CssProperty(73));

